const formatter = new Intl.NumberFormat('en-au', { style: 'currency', currency: 'AUD', minimumFractionDigits: 0, maximumFractionDigits: 0 });
const formatCurrency = number => formatter.format(number);

export default formatCurrency;
